import { render, staticRenderFns } from "./SearchMenu.vue?vue&type=template&id=7125ab10&scoped=true"
import script from "./SearchMenu.vue?vue&type=script&lang=js"
export * from "./SearchMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7125ab10",
  null
  
)

export default component.exports